import { render, staticRenderFns } from "./activeLucky.vue?vue&type=template&id=1b923dd5&"
import script from "./activeLucky.vue?vue&type=script&lang=js&"
export * from "./activeLucky.vue?vue&type=script&lang=js&"
import style0 from "./activeLucky.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports